import { render, staticRenderFns } from "./mainArea.vue?vue&type=template&id=45b0012a&scoped=true&"
import script from "./mainArea.vue?vue&type=script&lang=js&"
export * from "./mainArea.vue?vue&type=script&lang=js&"
import style0 from "./mainArea.vue?vue&type=style&index=0&id=45b0012a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b0012a",
  null
  
)

export default component.exports